
const actions = {
    TOGGLE_SIDEBAR: "TOGGLE_SIDEBAR",
    TOGGLE_SETTINGS: "TOGGLE_SETTINGS",
    TOGGLE_RIGHTBAR: "TOGGLE_RIGHTBAR",

    toggleSidebar :() => {
        return {
            type: actions.TOGGLE_SIDEBAR
        }
    },

    toggleSettings :() => {
        return {
            type: actions.TOGGLE_SETTINGS
        }
    },

    toggleRightbar :() => {
        return {
            type: actions.TOGGLE_RIGHTBAR
        }
    }

};

export default actions;
